import React from 'react';
import DesignWorkspace from './DesignWorkspace';

function DesignView() {
  return <DesignWorkspace />;
}

export default DesignView;

